module.exports = __webpack_public_path__ + "img/arrow_down.c6c53e81.svg";